





















let vm!: any;
import { Component, Vue} from 'vue-property-decorator';
import { UserViewModel, UserService } from '../../api/user';
import { MessageBox } from 'element-ui';
@Component({})
export default class UserPassword extends Vue {
  public service: UserService = new UserService();
  public data: UserViewModel = this.service.NewModel;
  public forgotUser: UserViewModel = {id: ''};
  public rules = {
    password: [{required: true, message: '请输入密码', trigger: 'blur'}],
    passwordn: [{required: true, message: '请输入新密码', trigger: 'blur'}],
    passwordc: [{required: true, message: '请输入确认密码', trigger: 'blur'},
      {validator(rule: any, value: any, callback: any, source: any, options: any) {
        const errors = [];
        if ( vm.data.passwordn !== value) {
          errors.push(new Error('请两次密码输入不一致！'));
        }
        callback(errors);
      }},
    ],
  };

  public mounted() {
    vm = this;
  }

  public btnSave_OnClick() {
    const validate = this.$refs['edit-form'] as any;
    validate.validate((valid: any) => {
      if (valid) {
        if (this.forgotUser === null || this.forgotUser === undefined || this.forgotUser.id === '') {
          this.service.ChangePassword(this.data).then((response: any) => {
            MessageBox.alert('修改成功', {type: 'success'});
            this.data = this.service.NewModel;
            validate.resetFields();
          });
        } else {
          this.forgotUser.passwordn = this.data.passwordn;
          this.forgotUser.passwordc = this.data.passwordc;
          this.service.ResetPassword(this.forgotUser).then((response: any) => {
            MessageBox.alert('修改成功', {type: 'success'});
            this.data = this.service.NewModel;
          });
        }
      }
    });
  }
}
